import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div id="footer" className="app-footer">
      <div className="row">
        <div className="col-md-12">
          <div className="copyrights">
            <span>© 2019 LogisticsNow. All Rights Reserved.</span>
            <span className="footer-link-container">
              <a
                href="https://lntermsandconditions.blob.core.windows.net/tnc/faq.html"
                className="link"
                target="_blank"
                rel="noopener noreferrer"
              >
                FAQs
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
